import queryString from 'query-string';
import {fetch} from 'whatwg-fetch';
import StorageToken from '@services/storage_token';
import {AppError} from '@assets/core/AppError';
import LanguageService from '@services/language/LanguageService';

export const checkAccessToken = (token) => {
    return fetch(`${location.origin}/sveden/update/api_profile_applicant/check_token.php`, {
        method: 'POST',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        body: queryString.stringify({access_token: token}),
    })
        .then((response) => { return response.json(); })
        .then((response) => {
            return response.success && response.success === 'ok';
        })
        .catch((err) => {
            return false;
        });
};
export const getAccessToken = async (login, password, code, t) => {
    const response = await fetch(`${location.origin}/sveden/update/api_profile_applicant/get_token.php`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: queryString.stringify({
            login,
            password,
            code,
            lang: LanguageService.getLang() || 'ru'
        }),
    });
    if (response.ok) {
        return response.json();
    }
    switch (response.status) {
        case 400:
            throw new AppError(t('invalid_email_or_password'), 400);
        case 403:
            throw new AppError(t('invalid_or_expired_code'), 403);
        case 422:
            throw new AppError((await response.json()).message, 422);
        case 429:
            throw new AppError(t('too_many_attempts'), 429);
        case 522:
            throw new AppError(t('connection_failed'), 522);
        default:
            throw new AppError(t('login_failed'), 500);
    }
};
export const refreshToken = () => {
    return new Promise((resolve, reject) => {
        const storageToken = new StorageToken();
        const refreshToken = storageToken.getRefreshToken();
        if (refreshToken) {
            const refreshTokenRequest = fetch(`${location.origin}/sveden/update/api_profile_applicant/refresh_token.php`, {
                method: 'POST',
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                body: queryString.stringify({
                    refresh_token: refreshToken,
                    redirect_url: location.origin + location.pathname,
                }),
            })
                .then((response) => { return response.json(); })
                .then((response) => {
                    if (response.access_token && response.access_token !== '') {
                        const storageToken = new StorageToken();
                        storageToken.setToken(response.access_token);
                        storageToken.setRefreshToken(response.refresh_token);
                        resolve(true);
                    }
                    resolve(false);
                })
                .catch((err) => {
                    resolve(false);
                });
        } else {
            resolve(false);
        }
    });
};

export const registrationUser = async (apiDomainAuth, data, t) => {
    const response = await fetch(`${apiDomainAuth}users/?redirect_uri=${location.href}`, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'App-Language': LanguageService.getLang() || 'ru'
        },
        body: queryString.stringify(data),
    });
    if (response.ok) {
        return true;
    }
    switch (response.status) {
        case 422:
            throw new AppError((await response.json()).message, 422);
        default:
            throw new AppError(t('failed_to_create_user'), 500);
    }
};

export const forgotPasswordUser = async (apiDomainAuth, login, t) => {
    const response = await fetch(`${apiDomainAuth}forgot-password/?redirect_uri=${location.href}`, {
        method: 'POST',
        mode: 'cors',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
            'App-Language': LanguageService.getLang() || 'ru'
        },
        body: queryString.stringify({email: login}),
    });
    if (response.ok) {
        return true;
    }
    switch (response.status) {
        case 422:
            throw new AppError((await response.json()).message, 422);
        default:
            throw new AppError(t('failed_to_send_password_reset_link'), 500);
    }
};

export const resetPasswordUser = async (apiDomainAuth, data, t) => {
    const response = await fetch(`${apiDomainAuth}reset-password`, {
        method: 'POST',
        mode: 'cors',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
            'App-Language': LanguageService.getLang() || 'ru'
        },
        body: queryString.stringify(data),
    });
    if (response.ok) {
        return true;
    }
    switch (response.status) {
        case 422:
            throw new AppError((await response.json()).message, 422);
        default:
            throw new AppError(t('failed_to_change_password'), 500);
    }
};

export const resetPasswordUserFromSettings = async (apiDomainAuth, data, t) => {
    const storageToken = new StorageToken();
    const accessToken = storageToken.getToken();
    const response = await fetch(`${apiDomainAuth}reset-password-from-settings`, {
        method: 'POST',
        mode: 'cors',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: `Bearer ${accessToken}`,
            'App-Language': LanguageService.getLang() || 'ru'
        },
        body: queryString.stringify(data),
    });
    if (response.ok) {
        return true;
    }
    switch (response.status) {
        case 422:
            throw new AppError((await response.json()).message, 422);
        default:
            throw new AppError(t('failed_to_change_password'), 500);
    }
};

export const getCaptcha = async (apiDomainAuth) => {
    const response = await fetch(`${apiDomainAuth}captcha/api`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            Accept: 'application/json',
        },
    });
    if (response.ok) {
        return response.json();
    }
    switch (response.status) {
        case 422:
            throw new AppError((await response.json()).message, 422);
        default:
            throw new AppError(
                LanguageService.getLang() === 'ru' ? 'Не удалось получить капчу' : 'Failed to get captcha',
                500);
    }
};

export const resendVerifyEmailToUser = async (apiDomainAuth, email, t) => {
    const response = await fetch(`${apiDomainAuth}resend-verify/?redirect_uri=${location.href}`, {
        method: 'POST',
        mode: 'cors',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
            'App-Language': LanguageService.getLang() || 'ru'
        },
        body: queryString.stringify({email}),
    });
    if (response.ok) {
        return true;
    }
    switch (response.status) {
        case 422:
            throw new AppError((await response.json()).message, 422);
        case 429:
            throw new AppError(t('too_many_attempts'), 429);
        default:
            throw new AppError(t('failed_to_send_confirmation_email'), 500);
    }
};
